// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"771811dd","455":"7ab4f915","977":"986e3885"}[chunkId] + ".chunk.js";
};